export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /root/anvel/angular/environments/environment.ts